import React from 'react';
import './Solutions.css';

const Solutions = ({ activeGroup }) => {
  const solutionGroups = {
    'everyday-digital': {
      colorClass: 'red',
      cards: [
        {
          title: 'Digital records instead of paper',
          body: 'Customer, sales, stock and appointment records in one place.'
        },
        {
          title: 'Day-to-day tools for operations',
          body: 'Billing, POS and reminders set up for everyday use.'
        },
        {
          title: 'Simple daily snapshot for the owner',
          body: 'A daily view of sales, open leads and follow-ups due.'
        },
        {
          title: 'Enquiry & lead capture in one list',
          body: 'Calls, WhatsApp, DMs and walk-ins captured in one list.'
        },
        {
          title: 'Smart front-desk replies (starter bots)',
          body: 'Welcome messages, FAQs and appointment confirmations.'
        }
      ]
    },
    'workflow-automation': {
      colorClass: 'yellow',
      cards: [
        {
          title: 'Workflow Mapping & Redesign',
          body: 'Redesigned steps and handoffs, from enquiry to renewal.'
        },
        {
          title: 'Customer Journey Flows',
          body: 'Timely reminders, renewals, follow-ups and service updates.'
        },
        {
          title: 'Connected Systems',
          body: 'WhatsApp, CRM, website and billing connected without re-entry.'
        },
        {
          title: 'Workflow Automation',
          body: 'Triggered replies, owner notifications and payment reminders.'
        },
        {
          title: 'Team Sync (Multi-Agent Logic)',
          body: 'One shared view of customer status across sales, service and owners.'
        }
      ]
    },
    'business-transformation': {
      colorClass: 'red',
      cards: [
        {
          title: 'Business & Digital Maturity Assessment',
          body: 'A baseline across processes, tools, data and team readiness.'
        },
        {
          title: 'Operations Automation at Scale',
          body: 'Less manual work across reporting, invoices, orders and supplier onboarding.'
        },
        {
          title: 'Customer Experience Automation at Scale',
          body: 'Lead capture, qualification, routing and follow-up with bots where useful.'
        },
        {
          title: 'Data & Decision Layer',
          body: 'Clear views of performance, revenue gaps and what is working.'
        },
        {
          title: 'Growth Levers: New Markets & New Products',
          body: 'Digital and AI support for new offers, markets and branch expansion.'
        },
        {
          title: 'Phase-wise transformation',
          body: 'A phased path from legacy operations to connected, AI-enabled workflows.'
        }
      ]
    },
    'creative-strategy': {
      colorClass: 'yellow',
      cards: [
        {
          title: 'Brand & USP Definition',
          body: 'Clear positioning, audience and reasons to choose your business.'
        },
        {
          title: 'Customer Segmentation & Market Insight',
          body: 'An understanding of customer groups and what matters to them.'
        },
        {
          title: 'Content & Channel Strategy',
          body: 'What to say, where to say it and how often.'
        },
        {
          title: 'Creative Development',
          body: 'Ads, videos, scripts and explainers sized for growing-business budgets.'
        },
        {
          title: 'Campaign Setup & Optimisation',
          body: 'Campaigns planned, run and refined around the right audience.'
        },
        {
          title: 'Launch & Visibility for New Products/Markets',
          body: 'Messaging and a digital presence for new products or markets.'
        }
      ]
    }
  };

  const solutionGroupIds = {
    'everyday-digital': 'everyday-digital-setup',
    'workflow-automation': 'ai-workflow-automation',
    'business-transformation': 'business-transformation-ai',
    'creative-strategy': 'creative-strategy-brand'
  };

  const titles = {
    'everyday-digital': 'Everyday Digital Setup',
    'workflow-automation': 'AI-Enabled Workflow Automation',
    'business-transformation': 'Business Transformation & AI Makeover',
    'creative-strategy': 'Creative Strategy & Brand Visibility'
  };
  const outputs = {
    'everyday-digital': ['Processes · daily routines', 'Systems · records & lead tracking', 'Automation · reminders', 'AI · front-desk replies'],
    'workflow-automation': ['Processes · redesigned handoffs', 'Automation · follow-ups', 'Integration · connected tools', 'Systems · shared status'],
    'business-transformation': ['Processes · operating model', 'Systems · decision dashboards', 'Automation · operations', 'AI · customer workflows', 'Integration · existing platforms'],
    'creative-strategy': ['Processes · campaign planning', 'Systems · customer journeys']
  };
  const currentGroup = solutionGroups[activeGroup];
  return (
    <section className={`solutions ${currentGroup?.colorClass || ''}`} id="solutions" aria-label="Selected service solutions">
      {currentGroup && <div className="container" id={solutionGroupIds[activeGroup]}>
        <div className="solution-panel" key={activeGroup}>
          <div className="solutions-header">
            <div><span className="solution-context">What this can include</span><h3 aria-live="polite">{titles[activeGroup]}</h3></div>
            <a href="/demo/" className="solution-examples">See working examples <span aria-hidden="true">↗</span></a>
          </div>
          <ul className="solution-tags" aria-label="Contextual outputs">{outputs[activeGroup].map(output => <li key={output}>{output}</li>)}</ul>
          <div className="solutions-grid">
            {currentGroup.cards.map(card => <div className="solution-card" key={card.title}><h4>{card.title}</h4><p>{card.body}</p></div>)}
          </div>
        </div>
      </div>}
    </section>
  );
};
export default Solutions;
